import $ from "jquery";
import "jquery.scrollto";
import BezierEasing from "bezier-easing";
import stage from "../components/stage";
import slick from "slick-carousel";

class Switch {
  constructor() {
    this.init();
  }

  init() {
    this.renderQue = this.render.bind(this);
    this.resizeQue = this.resize.bind(this);

    this.addEvents();
    console.log("switch.js loaded");
  }

  addEvents() {
    this.startPage();
  }

  startPage() {
    this.body = $("body");
    this.animate = $(".animate");
    this.pos = 0;
    this.parallaxHeader = $("#switch-header");

    this.initSlider();
    this.switchFormSend();
    stage.on("stage:scroll", this.renderQue);
    stage.on("stage:resize", this.resizeQue);
    this.resize();
  }

  removeEvents() {
    $.each(this.Animation, (index, el) => {
      TweenMax.killAll();
      index = null;
    });
    this.Animation = null;
    stage.removeListener("stage:scroll", this.renderQue);
    stage.removeListener("stage:resize", this.resizeQue);
  }

  switchFormSend() {
    $("#switch-form").submit(function (e) {
      /*
      e.preventDefault();
      $.ajax({
        type: "POST",
        url: Syngency.signup_form_url,
        data: $("#switch-form").serialize(), // serializes the form's elements.
      })
      .done(function() {
          console.log('done');
      });
      */
      $(this).hide();
      $("#switch-form-response").show();
    });
  }

  initSlider() {
    $("#switch-slider").slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      dots: false,
      fade: true,
      pauseOnHover: true,
      autoplay: true,
      autoplaySpeed: 3000,
    });
  }

  complete() {
    $("html").addClass("initialized");
    this.resize();
  }

  resize(e) {
    if (!e) {
      e = stage;
    }

    this.isMobile = e.w < 768;

    this.animate.each((i, el) => {
      const show = $(el);
      const showrect = show.offset();
      const showheight = show.height();
      const showwidth = show.width();
      const offset = show.data("offset") || 0;

      show.data("bottom", showrect.top + showheight);
      show.data("top", showrect.top + offset);
      show.data("left", showrect.left);
      show.data("width", showwidth);
      show.data("height", showheight);
    });

    //2400 = 1
    var max = Math.max(e.w, e.h);

    var scale = this.isMobile ? e.w / 768 : e.w / 1440;
    var obj = this.isMobile
      ? { scale: scale, force3D: true, x: 0, y: 0 }
      : { scale: scale, force3D: true };
    var angle = this.isMobile
      ? this.getAngleDeg(40, stage.w)
      : this.getAngleDeg(200, stage.w);

    $(".bg").each((index, el) => {
      var sign = el.dataset.orientation || -1;
      TweenMax.set(el, { rotation: sign * angle, force3D: true });
    });

    this.render(e);
  }

  render(e) {
    this.animate.each((i, el) => {
      const show = $(el);
      const showindex = show.data("height");
      const showtoken = show.data("top");
      const showinview = e.scrolltop + e.h > showtoken + showindex / 1.75;

      if (showinview) {
        show.addClass("animate-go");
      }
    });

    if (e.scrolltop < e.h + e.h / 3) {
      TweenMax.set(this.parallaxHeader, {
        y: -(e.scrolltop / 3),
        force3D: true,
      });
    }
  }

  getAngleDeg(a, b) {
    var angleRad = Math.atan(a / b),
      angleDeg = (angleRad * 180) / Math.PI;

    return angleDeg;
  }

  destroy() {
    //console.log('destroy')
  }
}

module.exports = Switch;
